import React from "react";
import DoctorLayout from "../../components/Layout/DoctorLayout-new";
import LayoutWithbg from "../../components/LayoutWithbg";
import DaycareLayout from "./components/DaycareLayout";

/**
 * Wraps Day Care pages the way OT does (OTAppShell): the hospital's top
 * navbar, the page background, then the module's own sidebar.
 */
export default function DaycareAppShell({ setSearchText, children }) {
  return (
    <DoctorLayout setSearchText={setSearchText}>
      <LayoutWithbg>
        <DaycareLayout>{children}</DaycareLayout>
      </LayoutWithbg>
    </DoctorLayout>
  );
}
